import { HeaderLogo } from "components";
import { FC, useEffect } from "react";
import img from "../../components/atoms/Logo/halal.jpeg";

export interface PageHomeProps {
    className?: string;
}

const Home: FC<PageHomeProps> = ({ className = "" }) => {

    useEffect(() => {

    }, []);

    return (
        <div className={`nc-PageLogin bg-gray-100 ${className} `} data-nc-id="PageLogin">
            <div className="container h-screen flex w-full justify-center items-center">
                <div className="bg-white p-4 h-64 -mt-40 rounded-xl">
                    <img
                        className={`w-56`}
                        src={img}
                        alt="Logo"
                    />
                </div>
            </div>
        </div>
    );
};

export default Home;
